import * as actionTypes from "./actionTypes";
import axios from "../../axios";
export const addIngredient = name => {
  return {
    type: actionTypes.ADD_INGREDIENT,
    ingredientName: name
  };
};
export const removeIngredient = name => {
  return {
    type: actionTypes.REMOVE_INGREDIENT,
    ingredientName: name
  };
};
export const setIngredients = ingredients => {
  return {
    type: actionTypes.SET_INGREDIENTS,
    ingredients: ingredients
  };
};
export const fetchIngredientFailed = () => {
  return {
    type: actionTypes.FETCH_INGREDIENTS_FAILED
  };
};
export const initIngredient = () => {
  return dispatch => {
    axios
      .get("ingredient.json")
      .then(res => {
        dispatch(setIngredients(res.data));
      })
      .catch(error => dispatch(fetchIngredientFailed()));
  };
};
